import { MODAL_SIZE } from '../../App.config';
import * as actionTypes from '../actionTypes';

export default function modalReducer(state = {
  isOpen: false,
  children: undefined,
  size: MODAL_SIZE.MODAL_MD, // This is new var for modal size
  disableClose: false
}, action) {
  switch (action.type) {
    case actionTypes.OPEN_MODAL:
      return Object.assign({}, state, {
        isOpen: true
      });
    case actionTypes.CLOSE_MODAL:
      return Object.assign({}, state, {
        isOpen: false
      });
    case actionTypes.OPEN_SET_MODAL:
      return Object.assign({}, state, {
        isOpen: true,
        children: action.children,
        size: action.size || MODAL_SIZE.MODAL_MD,
        disableClose: action.disableClose || false
      });
    case actionTypes.CLOSE_REMOVE_MODAL:
      return Object.assign({}, state, {
        isOpen: false,
        children: undefined,
        size: MODAL_SIZE.MODAL_MD
      });
    default:
      return state;
  }
}